import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router';

import { kebabToTitleCase } from 'utils/stringUtil';
import { isNotNullOrUndefined, isStringNotBlank } from 'utils/utils';

type Props = {
  alternateTitle?: string;
};

const PageTitleToken = ({ alternateTitle }: Props) => {
  const location = useLocation();
  const { tab } = useParams<{ tab: string }>();
  const pathTitle = kebabToTitleCase(location?.pathname?.split('/')?.[1]);
  const tabTitle = isStringNotBlank(tab) ? `- ${kebabToTitleCase(tab)}` : '';

  useEffect(() => {
    if (isNotNullOrUndefined(alternateTitle)) {
      document.title = `${alternateTitle} ${tabTitle}`;
    } else {
      document.title = `CLM ${pathTitle} ${tabTitle}`;
    }
  }, [pathTitle, tabTitle, alternateTitle]);

  return null;
};

export default PageTitleToken;
